import { useLayoutEffect, useRef } from "react";
import { type UseFormSetValue } from "react-hook-form";
import { roundNum } from "src/generator/utils/calcFeatures";

interface Props {
  id: string;
  value: unknown;
  decimals?: number | string;
  enabled?: boolean;
  setValue: UseFormSetValue<Record<string, any>>;
}

/** Rounds the cell to `decimals`: written values straight away, typed ones via `roundOnBlur`. */
const useRoundDecimals = ({
  id,
  value,
  decimals,
  enabled,
  setValue,
}: Props) => {
  const rounded = enabled ? roundNum(value, decimals) : null;
  const lastValue = useRef(value);
  const typed = useRef(false);

  // Layout effect, so an unrounded value is never painted
  useLayoutEffect(() => {
    if (lastValue.current === value) return;
    lastValue.current = value;
    if (typed.current) {
      typed.current = false;
      return;
    }
    if (rounded !== null) setValue(id, rounded);
  }, [id, rounded, setValue, value]);

  return {
    markTyped: () => {
      typed.current = true;
    },
    roundOnBlur: () => {
      typed.current = false;
      if (rounded !== null) setValue(id, rounded);
    },
  };
};

export default useRoundDecimals;
